import { ThemeProvider } from "@bonusx-global/bx-design-system";
import useMobileAppBannerVisibility from "../../hooks/useMobileAppBannerVisibility";
import MobileAppBanner from "./mobile-app-banner";

function MobileAppBannerWrapper(): JSX.Element | null {
  const isBannerVisible = useMobileAppBannerVisibility();

  if (!isBannerVisible) {
    return null;
  }

  return (
    <ThemeProvider>
      <MobileAppBanner />
    </ThemeProvider>
  );
}

export default MobileAppBannerWrapper;
